import { render, staticRenderFns } from "./SubactDetails.vue?vue&type=template&id=9405929e"
import script from "./SubactDetails.vue?vue&type=script&lang=js"
export * from "./SubactDetails.vue?vue&type=script&lang=js"
import style0 from "./SubactDetails.vue?vue&type=style&index=0&id=9405929e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports